import React from 'react';
import styled from 'styled-components';
import Input from 'components/forms/Input';
import InputLabel from '../common/InputLabel';
import FormRow from './FormRow';
import { getTotalDeductions } from './utils';
import OutputLabel from '../common/OutputLabel';

const Title = styled.h2`
    font-family: ${({ theme }) => theme.font.title};
    font-size: 1.9em;
    color: ${({ theme }) => theme.colour.dark};
    text-align: left;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
`;

const TotalRow = ({ formData, onInputChange, netProfit, currency }) => {
    const nightsString = formData.numberOfNights === 1 ? ' night' : ' nights';

    const fontSize = { fontSize: '2em' };

    return (
        <div>
            <Title>Cost of occupied room</Title>
            <hr style={{ marginBottom: '2em' }} />
            <FormRow
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    marginBottom: '1em',
                }}
            >
                <InputLabel className="pkgCalc-form-label" text="Cost of Occupied Room" />
                <Input
                    type="number"
                    required
                    name="costOfOccupiedRoom"
                    placeholder="0"
                    onChange={onInputChange}
                    className="pkgCalc-form-number"
                    value={formData.costOfOccupiedRoom.toString()}
                    addonBefore={currency}
                />
                <OutputLabel text={`${formData.numberOfNights.toString()}${nightsString}`} style={{ width: '20%' }} />
                <OutputLabel text={`${currency}${formData.totalCostOfOccupiedRoom.toString()}`} />
            </FormRow>

            <Title>Results</Title>
            <hr style={{ marginBottom: '2em' }} />
            <FormRow className="pkgCalc-form-total-label">
                <InputLabel text="Selling Price" style={fontSize} />
                <OutputLabel style={fontSize} text={`${currency}${formData.proposedRate.toString()}`} />
            </FormRow>
            <FormRow className="pkgCalc-form-total-label">
                <InputLabel text="Total Deductions" style={fontSize} />
                <OutputLabel style={fontSize} text={`${currency}${getTotalDeductions(formData).toString()}`} />
            </FormRow>
            <FormRow className="pkgCalc-form-total-label">
                <InputLabel text="Net Profit" style={fontSize} />
                <OutputLabel
                    style={fontSize}
                    text={`${currency}${(!Number.isNaN(netProfit) ? netProfit.toFixed(2) : 0).toString()}`}
                />
            </FormRow>
        </div>
    );
};

export default TotalRow;
